import lang from "translations";

const columns = [
  { key: "reservationId", text: lang.reservationId, custom: true, fixWidth: "90px", width: "w-auto" },
  { key: "status", text: lang.status, custom: true, fixWidth: "90px", width: "w-auto" },
  { key: "primaryGuestName", text: lang.primaryGuest, custom: true, fixWidth: "120px", width: "w-auto" },
  { key: "guestCount", text: lang.guestCount, custom: true, fixWidth: "80px", width: "w-auto" },
  { key: "resourceName", text: lang.resourceUsed, custom: true, fixWidth: "220px", width: "w-auto" },
  { key: "openedAt", text: lang.openedAt, custom: true, fixWidth: "130px", width: "w-auto" },
  { key: "closedAt", text: lang.closedAt, custom: true, fixWidth: "130px", width: "w-auto" },
  { key: "orderCount", text: lang.orders, custom: true, fixWidth: "80px", width: "w-auto" },
  { key: "billCount", text: lang.bills, custom: true, fixWidth: "80px", width: "w-auto" },
  { key: "totalPaidAmount", text: lang.totalPaidAmount, custom: true, align: "right", fixWidth: "140px", width: "w-auto" },
];

export default columns;
